import { selectPrerequisites } from "redux/reducers/entities/prerequisites"

import { PREREQUISITES } from "redux/reducers/entities/prerequisites/actionNames"

const mapper = {
    [PREREQUISITES](getState, result, originalPayload) {
        const { isRepublishing } = originalPayload || {}
        const state = getState()
        const clone = selectPrerequisites(state)

        return { result: isRepublishing ? clone : result, originalPayload }
    },
}

export default mapper
